import { Children, useState } from "react";
import { PageHider } from "./PageHider";

export const WeeklyPage = ({
  children,
  blue,
  cropped,
  pageId,
  onClick,
  isPageVisible,
  style,
}: any) => {
  const [pageVisible, setPageVisible] = useState<boolean>(
    isPageVisible !== undefined ? isPageVisible : true
  );

  return (
    <div
      onClick={() => {
        if (onClick) onClick();
      }}
      id={pageId}
      className={"page" + (pageVisible ? "" : " no-print")}
      style={{ fontFamily: "Open Sans", ...style }}
    >
      <PageHider pageVisible={pageVisible} setPageVisible={setPageVisible} />
      {!pageVisible && <div className="page-overlay"></div>}
      {children}
    </div>
  );
};
